
import { makeObservable, observable, computed, action } from 'mobx';


import { apiHost,erpApiurl } from './APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Receivables. The Service is unavailable. Please try after sometime." };

export default class ReceivableSummaryStore {

    state = PENDING;
    message = EMPTY_MESSAGE;

    branchSummary = new Map();
    branchTransactions = new Map();

    branchDues = [];
    labDues = [];
    
    selectedBranch = "No Branch Selected";
    selectedLab = undefined;
    selectedLabDetails = [];

    rowCount = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.collectionType = props.collectionType;
        this.stores = props.stores;
        this.grandTotal=0;
        this.branchTotal=0;

        makeObservable(this, {
            state: observable,
            message: observable,
            rowCount: observable,

            branchDues: observable,
            labDues: observable,
            selectedBranch: observable,
            selectedLab: observable,
            grandTotal:observable,
            branchTotal:observable,
            selectedLabDetails: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchBranchSummary: action,
            publishLabDues: action,
            fetchSelectedLabDetails: action,

            selectLab: action,
            clearSelectedLab: action,
        });
    }

    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    labRollup = (data) => {
        const branchId = data.BranchId;
        const refId = data.ReferrerId;

        var labMap = this.branchTransactions.get(branchId);

        if (labMap === undefined) {
            labMap = new Map();
            this.branchTransactions.set(branchId, labMap);
        }

        var labSummary = labMap.get(refId);
        if (labSummary === undefined) {
            labSummary = { branchId, refId, branchName: data.BranchName, labName: data.LabName, uiBillAmount: 0, uiReceived: 0, uiDue: 0, invBillAmount: 0, invReceived: 0, invDue: 0, totalDue: 0, collectionType: data.collectionType, iflag: data.flag };
            labMap.set(refId, labSummary);
        }

        this.rollup(labSummary, data);
    }

    branchRollup = (data) => {

        const branchId = data.BranchId;
        var summary = this.branchSummary.get(branchId);
        if (summary === undefined) {
            summary = { branchId, branchName: data.BranchName, uiBillAmount: 0, uiReceived: 0, uiDue: 0, invBillAmount: 0, invReceived: 0, invDue: 0, totalDue: 0, collectionType: data.collectionType, iflag: data.flag };
            this.branchSummary.set(branchId, summary);
        }
        this.rollup(summary, data);
    }

    rollup = (summary, data) => {
        if (data.flag === "ui") {
            summary.uiBillAmount += data.Total;
            summary.uiReceived += data.Advance;
            summary.uiDue += (data.Total - data.Advance);
        }
        else {
            summary.invBillAmount += data.Total;
            summary.invReceived += data.Advance;
            summary.invDue += (data.Total - data.Advance);
        }
       
        summary.iflag = data.flag;
        summary.collectionType = data.collectionType;
    }

    computeLabDue = () => {
        for(let aMap of this.branchTransactions.values()) {
            this.computeDue(aMap);
        }
    }

    computeDue = (aSummaryMap) => {
        for(let value of aSummaryMap.values()) {
            value.totalDue = value.uiDue+value.invDue;
        }
    }

    /**
     * Send the request to the endpoints using the FetchAPI
     * 
     */

    fetchBranchSummary = async () => {

        const dailyUrl = `${erpApiurl}api/Carbon/GetLabBillSummary?collectionType=daily`;
        const monthlyUrl = `${erpApiurl}api/Carbon/GetLabBillSummary?collectionType=monthly`;
        const weeklyUrl = `${erpApiurl}api/Carbon/GetLabBillSummary?collectionType=weekly`;
        const invoicedUrl = `${erpApiurl}api/Carbon/GetLabBillSummary?Paidstatus=1`

        this.branchTransactions.clear();
        this.branchSummary.clear();

        await this.performRollup(dailyUrl, "ui", "daily");
        await this.performRollup(monthlyUrl, "ui", "monthly");
        await this.performRollup(weeklyUrl, "ui", "weekly");
        await this.performRollup(invoicedUrl, "inv",);

        this.computeLabDue();
        this.computeDue(this.branchSummary);

        this.publishBranchDues();
    }

    publishBranchDues = () => {
        let total=0;
        const arr = [];
        for (let value of this.branchSummary.values()) {
            total+=value.totalDue;
            arr.push(value);
        }
        this.branchDues = arr;
        this.grandTotal=total
    }

    selectLab = (branchId, referrerId) => {
        let labMap = this.branchTransactions.get(branchId);
        this.selectedLab = labMap.get(referrerId);
        console.log(this.selectedLab)
    }

    clearSelectedLab = () => {
        this.selectedLab = undefined;
        this.selectedLabDetails = [];
    }

    publishLabDues = (branchId,branchName) => {
        let total=0
        
        let labSummary = this.branchTransactions.get(branchId);
        const arr = [];
        for (let value of labSummary.values()) {
            total+=value.totalDue;
            
            arr.push(value);
        }
        this.labDues = arr;
        this.selectedBranch = branchName;
        this.branchTotal=total
    }

    performRollup = async (url, flag, collectionType) => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            let response = await this.apiProxy.getAsync(url);
            let result = await response.json();

            let size = result.length;
            for (let i=0;i<size;i++) {
                let data = result[i];
                data.flag = flag;
                data.collectionType = collectionType;
                this.labRollup(data);
                this.branchRollup(data);
            }

            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    fetchSelectedLabDetails = async () => {
        
        const uninvoicedUrl = `${erpApiurl}api/Carbon/GetLabSideWiseSummary?ReferrerId=${this.selectedLab.refId}&collectionType=${this.selectedLab.collectionType}`;
        
        let uninvoicedData =[];
        if(this.selectedLab.collectionType !== undefined) {
            uninvoicedData = await this.fetchByUrl(uninvoicedUrl);
        }
        
        let invoicedData = await this.fetchInvoices();

        this.selectedLabDetails = this.mergeInvoiceData(uninvoicedData, invoicedData);
    }

    mergeInvoiceData = (uninvoiced,invoiced) => {
        const data = [];

        for(let i=0;i<uninvoiced.length;i++) {
            const item = uninvoiced[i];
            const due = item.Total-item.PaidAmount;
            if(due <= 0) {
                continue;
            }
            const buffer = {docNumber:item.SidCode, bucket:item.Bucket, billAmount:item.Total, received:item.PaidAmount, due, age:0};
            data.push(buffer);
        }
        for(let i=0;i<invoiced.length;i++) {
            const item = invoiced[i];
            const due = item.BillTotal-item.AdvanceTotal;
           
            if(due <= 0) {
                continue;
            }
            const buffer = {docNumber:item.InvoiceNumber, bucket:item.bucket, billAmount:item.BillTotal, received:item.AdvanceTotal, due, age:0};
            data.push(buffer);
        }
        return data;
    }

    fetchByUrl = async (url) => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return [];
            }
            this.state = DONE;
            return data;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
        return [];
    }

    fetchInvoices = async () => {
        const dailyUrl = `${erpApiurl}api/Carbon/GetLabInvioceSummary?ReferrerId=${this.selectedLab.refId}&collectionType=daily`
        const monthlyUrl = `${erpApiurl}api/Carbon/GetLabInvioceSummary?ReferrerId=${this.selectedLab.refId}&collectionType=monthly`

        let dailyData = await this.fetchByUrl(dailyUrl);
        let monthlyData = await this.fetchByUrl(monthlyUrl);

        this.dailyInvoicesCount = dailyData.length;
        this.monthlyInvoicesCount = monthlyData.length;

        let invoicedData = this.merge(dailyData,monthlyData);
        return invoicedData;
    }

    merge = (daily,monthly) => {
        const data = [];

        for(let i=0;i<daily.length;i++) {
            const item = daily[i];
            item["collectionType"] = "daily";
            data.push(item);
        }

        for(let i=0;i<monthly.length;i++) {
            const item = monthly[i];
            item["collectionType"] = "monthly";
            data.push(item);
        }

        let invoices = data;
        return invoices;
    }
}
